
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const CallToAction = () => {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  return (
    <section ref={ref} className="py-16 bg-card/30">
      <div className="container mx-auto px-4">
        <div className={`bg-card/50 p-8 md:p-12 rounded-lg text-center transition-all duration-700 ${isVisible ? 'animate-scale-in' : 'opacity-0 scale-95'}`}>
          <h2 className="text-2xl md:text-4xl font-bold mb-4">Ready to Transform Your Real Estate Business?</h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            Join Go Dyspo today and start connecting with qualified investors looking for their next property.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/seller/register">
              <Button size="lg" className="bg-godyspo-gold text-godyspo-background hover:bg-godyspo-gold/90 w-full sm:w-auto hover-lift group">
                Create Free Account
                <span className="ml-2 transition-transform group-hover:translate-x-1">→</span>
              </Button>
            </Link>
            <Link to="/login">
              <Button size="lg" variant="outline" className="border-white text-white w-full sm:w-auto hover-lift">
                Log In
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
